import React from "react";

import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    Tooltip,
    ResponsiveContainer,
    Label,
    CartesianGrid,
    Scatter,
} from "recharts";
import ErrorIcon from '@mui/icons-material/Error';

let dataFake =  [

]
let data3 = [
    {
      OD: 4
    },
    {
        OD: 4
      },{
        OD: 4
      },{
        OD: 4
      },{
        OD: 4
      },
      {
        OD: 4
      },
      {
          OD: 4
        },{
          OD: 4
        },{
          OD: 4
        },{
          OD: 4
        },{
            OD: 4
          },
          {
              OD: 4
            },{
              OD: 4
            },{
              OD: 4
            },{
              OD: 4
            },{
                OD: 4
              },
              {
                  OD: 4
                },{
                  OD: 4
                },{
                  OD: 4
                },{
                  OD: 4
                },{
                    OD: 4
                  },
                  {
                      OD: 4
                    },{
                      OD: 4
                    },{
                      OD: 4
                    },{
                      OD: 4
                    },
    {
      OD: 4.2
    },{
      OD: 3.5
    },{
        OD: 4.2
      },{
        OD: 3.5
      },{
        OD: 4.2
      },{
        OD: 3.5
      },{
        OD: 4.2
      },{
        OD: 3.5
      },
      {
          OD: 4
        },{
          OD: 4
        },{
          OD: 4
        },{
          OD: 4
        },{
            OD: 4
          },
          {
              OD: 4
            },{
              OD: 4
            },{
              OD: 4
            },{
              OD: 4
            },
{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},
{
    OD: 4
  },{
    OD: 4
  },{
    OD: 4
  },{
    OD: 4
  },{
      OD: 4
    },
    {
        OD: 4
      },{
        OD: 4
      },{
        OD: 4
      },{
        OD: 4
      },
{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},{
OD: 4.2
},{
OD: 3.5
},
{
    OD: 7
  },{
    OD: 5
  },{
    OD: 6
  },{
    OD: 6
  },{
      OD: 6
    },
    {
        OD: 6
      },{
        OD: 6
      },{
        OD: 6
      },{
        OD: 5
      },
{
OD: 6.2
},{
OD: 7.5
},{
OD: 5.2
},{
OD: 6.5
},{
OD: 7.2
},{
OD: 6.5
},{
OD: 7.2
},{
OD: 6.5
},
{
    OD: 7
  },{
    OD: 5
  },{
    OD: 6
  },{
    OD: 6
  },{
      OD: 6
    },
    {
        OD: 6
      },{
        OD: 6
      },{
        OD: 6
      },{
        OD: 5
      },
{
OD: 6.2
},{
OD: 7.5
},{
OD: 5.2
},{
OD: 6.5
},{
OD: 7.2
},{
OD: 6.5
},{
OD: 7.2
},{
OD: 6.5
},{
      OD: 23
    },{
      OD: 25
    },{
      OD: 23
    },{
      OD: 18
    },{
      OD: 23
    },{
      OD: 23
    },{
      OD: 23
    },{
      OD: 18
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 21
    },{
      OD: 23
    },
    {
        OD: 23
      },{
        OD: 25
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 25
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 25
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 25
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 23
      },{
        OD: 18
      },{
        OD: 21
      },{
        OD: 21
      },{
        OD: 39
      },{
        OD: 38
      },{
        OD: 38
      },{
        OD: 38
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 25
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 70
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },
      {
        OD: 90
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 80
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 83
      },{
        OD: 82
      },
      {
        OD: 85
      },{
        OD: 85
      },{
        OD: 80
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 83
      },{
        OD: 82
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 35
      },{
        OD: 70
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },{
        OD: 65
      },
      {
        OD: 90
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 80
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 83
      },{
        OD: 82
      },
      {
        OD: 85
      },{
        OD: 85
      },{
        OD: 80
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 85
      },{
        OD: 83
      },{
        OD: 82
      },
  ];
let ScatterData1 = {
    OD:38,
    time: '2/1/2020'
}

const DateNow = () =>{
    var today = new Date();
    var dd = String(today.getDate()).padStart(2, '0');
    var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
    var yyyy = today.getFullYear();
    return today = mm + '/' + dd + '/' + yyyy;

}

const CustomizedDot = (props) => {
    const { cx, cy, stroke, payload, value } = props;

    if (payload.OD ===25 && payload.time==='3/11/2021') {
      return (
         <svg x={cx - 15} y={cy - 35} width={30} height={30} fill="red" viewBox="0 0 1024 1024">
         <ErrorIcon style={{color:"#ffab00"}}/>
          {/* <path d="M512 1009.984c-274.912 0-497.76-222.848-497.76-497.76s222.848-497.76 497.76-497.76c274.912 0 497.76 222.848 497.76 497.76s-222.848 497.76-497.76 497.76zM340.768 295.936c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM686.176 296.704c-39.488 0-71.52 32.8-71.52 73.248s32.032 73.248 71.52 73.248c39.488 0 71.52-32.8 71.52-73.248s-32.032-73.248-71.52-73.248zM772.928 555.392c-18.752-8.864-40.928-0.576-49.632 18.528-40.224 88.576-120.256 143.552-208.832 143.552-85.952 0-164.864-52.64-205.952-137.376-9.184-18.912-31.648-26.592-50.08-17.28-18.464 9.408-21.216 21.472-15.936 32.64 52.8 111.424 155.232 186.784 269.76 186.784 117.984 0 217.12-70.944 269.76-186.784 8.672-19.136 9.568-31.2-9.12-40.096z" /> */}
        </svg>
      );
    }
  
    return (
     null
    );
  };


export default function OilConditionChart( {OilCondData}) {

  

    var today = new Date();
    var date = today.getDate()+'/'+(today.getMonth()+1)+'/'+today.getFullYear();
    var month = today.getMonth()+1;
  var realYear = today.getFullYear();

 var setAllZero = false;
   var varian =1;
   var dd = 1;
   var mm = 3;
   var year = 2020;
   var lastValue = Number(18);
   var randomNumber;
   var expArrayLastValue;
    data3.forEach(element => {

      

        element.time = dd + '/' + mm  + '/' + year;
      if(realYear === year && !setAllZero){
        if(month < mm)
          setAllZero = true;
          element.Prognosis = element.OD;
      }  

      if(setAllZero){
        element.OD = undefined;
        element.Prognosis = lastValue;
        if(element.Prognosis <95)
          {
            randomNumber = (Math.floor(Math.random()*2)-0.5);
            lastValue = lastValue + randomNumber 
          } 
        
          if(element.Prognosis < 98 ){

            element.Prognosis = lastValue = Math.pow(lastValue,1.00235);
          }
          else{
            element.Prognosis = 100;
          }
      }
      else{
        element.Prognosis = undefined;

      }

        varian ++;
        if( varian ===6){
            mm++;
            varian = 1;
        }
    
        if(mm === 13){
            mm = 1;
            year++;
        }
        dd++;
        if(dd === 21){
          dd = 1
        }

     

    });


    return (
        <div style={{ width: "62%", height: "310px" }}>
            <ResponsiveContainer>
                <AreaChart
                    data={data3}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 10,
                        bottom: 20,
                    }}
                >
                    <defs>
                        <linearGradient id="colorOD1" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="0%" stopColor="#66bb6a" stopOpacity={1} />
                            <stop offset="60%" stopColor="#66bb6a" stopOpacity={0.6} />
                        </linearGradient>
                          <linearGradient id="colorFake" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="15%" stopColor="#002984" stopOpacity={0.5} />
                      <stop offset="100%" stopColor="#002984" stopOpacity={0.1} />
                  </linearGradient>

                        <filter id="shadow" height="200%">
                            <feDropShadow dx="0" dy="10" stdDeviation="10" />
                        </filter>

                    </defs>

                    <XAxis  dataKey="time" minTickGap={60} axisLine={true} hide={false}
                        stroke="lightGrey"
                     >
                        <Label
                            value='Time'
                            position='bottom'
                            fontSize={18}
                            fill='lightGrey'
                        />
                    </XAxis>
                    <YAxis type="number" domain={[0, 100]}
                        stroke="lightGrey"
                     >
                        <Label
                            value="OD %"
                            angle={-90}
                            position="insideLeft"
                            fill='lightGrey'
                            frontSize={"18"}

                        />
                    </YAxis>
                    <Tooltip />
                    <line

                        fillOpacity={2}
                        fill="#ffeb3b"
                        filter="url(#shadow)"
                    />
                    <CartesianGrid strokeDasharray="3 3" strokeOpacity={0.7} />
                    <Area
                    dot={<CustomizedDot />}
                        stroke="#66bb6a"
                        type="natural"
                        dataKey="OD"
                        strokeLinecap="round"
                        fillOpacity={1}
                        fill="url(#colorUv)"
                    />
                      <Area
                        stroke="#3f51b5"
                        type="natural"
                        dataKey="Prognosis"
                        strokeLinecap="round"
                        fillOpacity={1}
                        fill="url(#colorFake)"
                    />

                </AreaChart>
            </ResponsiveContainer>
        </div>
    );
}

